import { useContext } from "react";
import { Stack, Typography, Grid, Box } from "@mui/material";
import moment from "moment";
//Import from project
import "../../Style/pagestyle.scss";
import LoginImage from "../../Assets/logoSystem.png";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import LoadingPage from "../../Utils/LoadingPage";
import EmptyData from "../Include/EmptyData/EmptyData";
import useGetPerformanceReport from "../../Hooks/useGetPerformanceReport";

export default function PerformanceReport({
  componentRef,
  classId,
  performanceTypeId,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const { tableData, loading } = useGetPerformanceReport({
    classId,
    performanceTypeId,
  });

  // console.log("tableData::", tableData);

  return (
    <div className="page-container">
      <Stack
        sx={{ padding: "20px" }}
        direction={"column"}
        spacing={1}
        ref={componentRef}
      >
        <Box>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <Stack direction="row" justifyContent={"left"}>
                <img alt="Logo" src={LoginImage} style={{ width: "120px" }} />
              </Stack>
            </Grid>
            <Grid item xs={4}>
              <Typography className="report-table-title">
                {t("student_performance_list")}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        {/* ================================ Table student and parents info ============================ */}
        <table className="report-table-container">
          <thead>
            <tr>
              <th style={{ width: "4%" }}>{t("no")}</th>
              <th style={{ width: "20%" }}>{t("page_performance_type")}</th>
              <th style={{ width: "16%" }}>{t("thead_full_name")}</th>
              <th style={{ width: "6%" }}>{t("thead_gender")}</th>
              {/* <th style={{ width: "16%" }}>{t("thead_date_of_birth")}</th> */}
              <th style={{ width: "18%" }}>{t("thead_class")}</th>
              <th style={{ width: "12%" }}>{t("thead_subject")}</th>
              <th style={{ width: "24%" }}>{t("thead_performance")}</th>
            </tr>
          </thead>

          {loading ? (
            <tbody>
              <tr>
                <td colSpan={16}>
                  <LoadingPage />
                </td>
              </tr>
            </tbody>
          ) : (
            <>
              {tableData?.length === 0 ? (
                <tbody>
                  <tr>
                    <td colSpan={16}>
                      <EmptyData />
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {tableData?.map((data, index) => {
                    // console.log("data", data)
                    return (
                      <tr key={index}>
                        <td align="center">{index + 1}</td>
                        {/* <td align="center">{data?.studentId?.studentId}</td> */}
                        <td>
                          {language === "en"
                            ? data?.performanceTypeId?.enName
                            : data?.performanceTypeId?.khName}{" "}
                          (
                          {data?.performanceTypeId?.date &&
                            moment(data?.performanceTypeId?.date).format(
                              "DD MMM YYYY"
                            )}
                          )
                        </td>
                        <td>
                          {data?.studentId?.familyName +
                            " " +
                            data?.studentId?.studentName}
                        </td>
                        <td align="center">
                          {data?.studentId?.gender === "Male"
                            ? t("thead_male")
                            : t("thead_female")}
                        </td>
                        <td>
                          {data?.classId?.courseId?.enName +
                            " " +
                            data?.classId?.className}
                        </td>
                        <td>{data?.subjectId?.enName}</td>
                        <td>{data?.description}</td>
                      </tr>
                    );
                  })}
                </tbody>
              )}
            </>
          )}
        </table>
      </Stack>
    </div>
  );
}
